<template>
    <div class="main container">
        <messageController></messageController>
        <simulation-banner v-if="!scenarioSelected"> </simulation-banner>
        <div class="row">
            <div class="col-xs-12">
                <h1>{{translate('Log.text19')}}</h1>
                <ul>
                    <li v-for="item in eventsLog" v-bind:key="item.entityId + '_' + eventsLog.indexOf(item)">
                        <template>{{translate('Log.' + item.content, item.content)}}</template>
                    </li>
                </ul>
            </div>

        </div>
        <userBar> </userBar>
        <page-title :title="translate('Log.text19')"> </page-title>
    </div>
</template>

<script>

    import userBar from '@/components/userBar.vue';
    import messageController from '@/components/messageController.vue';
    import pageTitle from "../components/pageTitle";
    import moment from 'moment';
    import simulationBanner from "../components/simulationBanner";
    import translate from '../mixins/translate.js';
    import getPropertyValue from '../mixins/getPropertyValue.js';
    export default {
        name: "userLog",
        components: {
            userBar,
            messageController,
            pageTitle,
            simulationBanner
        },
        methods: {
            getGPSList(entities = []) {
                const entityArray = [];
                for(const entity of entities){
                    if(entity && this.hasLocation(entity)){
                        entityArray.push(entity);
                    }
                }
                return entityArray;
            },
            hasLocation(entity){
                return !!getPropertyValue(entity, 'gpsLatLng');
            },
            timeDiff(start, end){
                let startTime = moment(start, "HH:mm:ss");
                let endTime = moment(end, "HH:mm:ss");

                let diff = endTime.diff(startTime);
                return moment.utc(diff).format("HH:mm:ss")
            },
            isTimePassed(time){
                let currentTime = moment(this.virtualTime, "HH:mm:ss");
                let testedTime = moment(time, "HH:mm:ss");

                let diff = currentTime.diff(testedTime);
                return diff > 0;
            },
            getCrewCallSign(crewId){
                const crew = this.$store.getters.getEntity(crewId);
                return crew ? getPropertyValue(crew, 'volaciZnak') : "";
            },
            getHospitalName(hospitalId){
                const hospital = this.$store.getters.getEntity(hospitalId);
                return hospital ? getPropertyValue(hospital, 'name') : "";
            },
            doEventLogTime: function(dataSource, created, text, content){
                if(dataSource)
                {
                    content.push({time: dataSource, content: dataSource + " [+"+ this.timeDiff(created, dataSource) +"]: " + translate('Log.' + text)})
                }
            },
            doEventLogCrew: function(dataSource, created, text, content){
                if(dataSource)
                {
                    dataSource.forEach(row => {
                        if(this.isTimePassed(row.time)) {
                            content.push({time: row.time, content: row.time + " [+"+ this.timeDiff(created, row.time) +"]: " + translate('Log.' + text)
                                + " (#" + this.getCrewCallSign(row.crewId)
                                + (row.hospitalId ? (", " + this.getHospitalName(row.hospitalId)) : "")
                                + (row.wardName ? (", " + row.wardName) : "")
                                + ")"})
                        }
                    });
                }
            },
            timeReady(entity) {
                return getPropertyValue(entity, 'pripravenoCasStr');
            },
            timeSummons(entity) {
                return getPropertyValue(entity, 'summonTimesStr');
            },
            timeDepartureFromBases(entity) {
                return getPropertyValue(entity, 'departureFromBaseTimesStr');
            },
            timeCrewArrives(entity) {
                return getPropertyValue(entity, 'crewArriveTimesStr');
            },
            timeCrewDepartureToHospitals(entity) {
                return getPropertyValue(entity, 'crewDepartureToHospitalTimesStr');
            },
            timeCrewHandoverInHospitals(entity) {
                return getPropertyValue(entity, 'crewHandoverInHospitalTimesStr');
            },
            timeRecallFromEvents(entity) {
                return getPropertyValue(entity, 'recallFromEventTimesStr');
            },
            timeArchive(entity) {
                return getPropertyValue(entity, 'archiveTimeStr');
            },
            timeForward(entity) {
                return getPropertyValue(entity, 'forwardTimeStr');
            },
            timeCancel(entity) {
                return getPropertyValue(entity, 'cancelTimeStr');
            },
            timeWaitingFromCancel(entity) {
                return getPropertyValue(entity, 'waitingFromCancelTimeStr');
            },
            timeWaitingFromForward(entity) {
                return getPropertyValue(entity, 'waitingFromForwardTimeStr');
            },
            timeAssignedFromArchive(entity){
                return getPropertyValue(entity, 'assignedFromArchiveTimeStr');
            },
            timeHospitalAssigned(entity){
                return getPropertyValue(entity, 'assignedHospitalTimeStr');
            },
            timeWardAssigned(entity){
                return getPropertyValue(entity, 'assignedWardTimeStr');
            },
            virtualTime(){
                return new Date(this.$store.state.time.time).toTimeString().substring(0, 8);
            },

            getLogFromEvent(entity) {

                let content = [];
                // "Volání"
                let created = getPropertyValue(entity, 'casVzniku');
                content.push({time: created, content: created + " [+00:00:00]: " + translate('Log.text9')});


                // "Připravení události"
                this.doEventLogTime(this.timeReady(entity), created, 'text3', content);

                // "Výzva VSK (#ID)"
                this.doEventLogCrew(this.timeSummons(entity), created, 'text4', content);

                // "Odjezd k události (#ID)"
                this.doEventLogCrew(this.timeDepartureFromBases(entity), created, 'text10', content);

                // "Příjezd k události (#ID)"
                this.doEventLogCrew(this.timeCrewArrives(entity), created, 'text5', content);

                // "Odjezd do ZZ (#ID, Cílová nemocnice)"
                this.doEventLogCrew(this.timeCrewDepartureToHospitals(entity), created, 'text6', content);

                // "Předání v ZZ (#ID, Cílové oddělení)"
                this.doEventLogCrew(this.timeCrewHandoverInHospitals(entity), created, 'text7', content);

                // "Odvolání (#ID)"
                this.doEventLogCrew(this.timeRecallFromEvents(entity), created, 'text11', content);

                // "Archivace události"
                this.doEventLogTime(this.timeArchive(entity), created, 'text8', content);

                // "Předání události"
                this.doEventLogTime(this.timeForward(entity), created, 'text12', content);

                // "Storno události"
                this.doEventLogTime(this.timeCancel(entity), created, 'text13', content);

                // "Zrušení storna události"
                this.doEventLogTime(this.timeWaitingFromCancel(entity), created, 'text14', content);

                // "Zrušení předání události"
                this.doEventLogTime(this.timeWaitingFromForward(entity), created, 'text15', content);

                // "Zrušení archivace události"
                this.doEventLogTime(this.timeAssignedFromArchive(entity), created, 'text16', content);


                // "Nastavení ZZ (cíl)"
                if(this.timeHospitalAssigned(entity)) {
                    const hospitalId = getPropertyValue(entity, 'nemocnice');
                    content.push({time: this.timeHospitalAssigned(entity) , content: this.timeHospitalAssigned(entity) + " [+ "+ this.timeDiff(created, this.timeHospitalAssigned(entity)) +"]: " + translate('Log.text17') + " (" + this.getHospitalName(hospitalId) + ")"})
                }

                // Nastavení oddělení ZZ (cíl)
                if(this.timeWardAssigned(entity)) {
                    const ward = getPropertyValue(entity, 'oddeleni');
                    content.push({time: this.timeWardAssigned(entity) , content: this.timeWardAssigned(entity) + " [+ "+ this.timeDiff(created, this.timeWardAssigned(entity)) +"]: " + translate('Log.text18') + " (" + ward + ")"})
                }

                content.sort((a,b) => (a.time.localeCompare(b.time)));
                let eventLog = [];
                content.forEach(row => eventLog.push({
                    content: row.content,
                    entityId: entity.entityId,
                    time: row.time
                }));
                return eventLog;
            },
        },
        computed: {
            scenarioSelected(){
                return this.$store.state.scenarioSelected;
            },
            events () {
                const waitingEvents = this.$store.state.simulation.lists.waitingEvents || [];
                const assignedEvents = this.$store.state.simulation.lists.assignedEvents || [];
                const archivedEvents = this.$store.state.simulation.lists.archivedEvents || [];

                return this.getGPSList([...waitingEvents, ...assignedEvents, ...archivedEvents]);
            },
            eventsLog() {
                let log = [];
                this.events.map(e => log.push(...this.getLogFromEvent(e)));
                return log;
            }
        }
    }
</script>

<style scoped>
    .main {
        padding-top: 20px;
    }
    h1 {
        margin-bottom: 40px;
    }
</style>
